import { AnchorHTMLAttributes } from 'react';
import { clsx } from 'clsx';
import s from './TextLink.module.scss';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
  text: string;
  href: string;
}

export const TextLink = ({ text, href, className, ...props }: Props) => {
  return <a className={clsx(s.link, className)} href={href}  {...props} >{text}</a>;
};